import { createContext } from "react";

import { ResolvedSite } from "resolvers/data/siteResolver";
import { Vehicle } from "schema-dts";
import { NearestAvailability } from "services/motorpoint/getEarliestBookingSlots";
import { VehicleService } from "services/vehicle/vehicle";

import useClosestStores from "./useClosestStores";

export type ClosestStoresContextProps = {
    closestStores: Record<string, any>[];
    hasClosestStores: boolean;
    getClosestStores: (params: any) => void;
    lastPostcode: string;
    allStoresDetailsData: ResolvedSite[];
    reset: () => void;
    error: string;
} | null;

export type ClosestStoresProviderProps = {
    closestStores: NearestAvailability[];
    allStoresDetails: ResolvedSite[];
    children: React.ReactNode;
    vehicle: VehicleService.Vehicle;
};

export const ClosestStoresContext = createContext<ClosestStoresContextProps>(null);

const ClosestStoresProvider: React.FC<ClosestStoresProviderProps> = ({
    children,
    closestStores,
    allStoresDetails,
    vehicle,
}) => {
    const value = useClosestStores(closestStores, allStoresDetails, vehicle);

    return <ClosestStoresContext.Provider value={value}>{children}</ClosestStoresContext.Provider>;
};

export default ClosestStoresProvider;
